//chapter1
export default {
    id : 4,//chapter number
    title : '04. FMEA 개요 (4) - FMEA 종류와 정보구성과 연계',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c04.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'FMEA 종류',
                'FMEA 정보구성과 연계',
            ],
            body2 : [
                'FMEA 종류에 대해 설명할 수 있다.',
                'FMEA 정보구성과 연계에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '04.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : 'FMEA의 결과는 관리계획서와 관계없다.',//html available
                    answer : "2",
                    explain : '공정 FMEA의 결과는 관리계획으로 연계되어야한다.'
                },
                {
                    type : 'ox',
                    question : '설계 FMEA의 결과는 공정 FMEA다.',//html available
                    answer : "2",
                    explain : '설계 FMEA의 결과는 설계사양이다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. 설계 FMEA</h3>
                        <li>제품이 고객의 의도된 사용목적을 충족할 수 있도록 하는 제품의 설계 및 설정된 사양(Spec) 개발에 초점을 둠</li>
                        <p class="mg10"></p>
                        <h3>2. 공정 FMEA</h3>
                        <li>제품이 설계도면의 사양(Spec)대로 반복적으로 제품이 생산될 수 있도록 하는 제조공정에 초점을 둠</li>
                        <li>잠재적 공정의 고장형태를 규명하고 이를 제거하기 위해서는 공정의 지식 및 공정데이터 이력을 활용하여야 함</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <h3>3. 설계 FMEA와 공정 FMEA의 연결 구조</h3>
                        <p class="mg10"></p>
                        <h3>4. FMEA와 관리계획의 정보연결 방안</h3>
                        <li>관리계획 작성과 FMEA의 역할</li>
                        <li>RISK 평가와 정보연계 내용</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c04.mp4',
        },
    ]
}